import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { Language } from '../language.model';

@JsonObject('LanguagesResultsResponse')
export class LanguagesResultsResponse extends ApiResultsResponse<Language> {

  @JsonProperty('results', [Language])
  override results: Language[] = [];

}
